module.exports = __webpack_public_path__ + "img/xls.cbc533b3.svg";